export default __webpack_public_path__ + "static/content-2-mobile-19930a28f6f5df9096a95a605377275a.png";